// extracted by mini-css-extract-plugin
export default {"heading":"DataExplorer_heading__a3UXl","title":"DataExplorer_title__7CXSq","infoIcon":"DataExplorer_infoIcon__BgYwI","infoText":"DataExplorer_infoText__H3rFh"};